"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProApiClient = void 0;
const ApiError_1 = require("./ApiError");
const ProApiObfuscationResult_1 = require("./ProApiObfuscationResult");
class ProApiClient {
    constructor(config) {
        var _a;
        this.config = {
            apiToken: config.apiToken,
            timeout: (_a = config.timeout) !== null && _a !== void 0 ? _a : ProApiClient.defaultTimeout,
            version: config.version
        };
    }
    static hasProFeatures(options) {
        return options.vmObfuscation === true || options.parseHtml === true;
    }
    async obfuscate(sourceCode, options = {}, onProgress) {
        if (!ProApiClient.hasProFeatures(options)) {
            throw new ApiError_1.ApiError('Obfuscator.io Pro obfuscation works only when Pro features set.', 400);
        }
        const requestBody = JSON.stringify({
            code: sourceCode,
            options
        });
        const bodySize = Buffer.byteLength(requestBody, 'utf8');
        if (bodySize > ProApiClient.blobUploadThreshold) {
            return this.obfuscateWithBlobUpload(sourceCode, options, requestBody, onProgress);
        }
        return this.obfuscateDirect(requestBody, onProgress);
    }
    async obfuscateDirect(requestBody, onProgress) {
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/x-ndjson',
            'Authorization': `Bearer ${this.config.apiToken}`
        };
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), this.config.timeout);
        let url = ProApiClient.apiUrl;
        if (this.config.version) {
            url = `${ProApiClient.apiUrl}?version=${encodeURIComponent(this.config.version)}`;
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers,
                body: requestBody,
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            return this.handleStreamingResponse(response, onProgress);
        }
        catch (error) {
            clearTimeout(timeoutId);
            if (error instanceof Error && error.name === 'AbortError') {
                throw new ApiError_1.ApiError('Request timeout', 408);
            }
            throw error;
        }
    }
    async obfuscateWithBlobUpload(sourceCode, options, legacyRequestBody, onProgress) {
        onProgress === null || onProgress === void 0 ? void 0 : onProgress('Uploading large file...');
        const followUpSize = Buffer.byteLength(JSON.stringify({ blobUrl: '', blobFormat: 'raw', options }), 'utf8') +
            ProApiClient.followUpBodyHeadroom;
        const useRawFormat = followUpSize <= ProApiClient.blobUploadThreshold;
        const blobUrl = useRawFormat
            ? await this.uploadToBlob('obfuscate-source.js', sourceCode, 'text/plain')
            : await this.uploadToBlob('obfuscate-request.json', legacyRequestBody, 'application/json');
        const followUpBody = useRawFormat
            ? JSON.stringify({ blobUrl, blobFormat: 'raw', options })
            : JSON.stringify({ blobUrl });
        onProgress === null || onProgress === void 0 ? void 0 : onProgress('File uploaded, starting obfuscation...');
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/x-ndjson',
            'Authorization': `Bearer ${this.config.apiToken}`
        };
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), this.config.timeout);
        let url = ProApiClient.apiUrl;
        if (this.config.version) {
            url = `${ProApiClient.apiUrl}?version=${encodeURIComponent(this.config.version)}`;
        }
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers,
                body: followUpBody,
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            return this.handleStreamingResponse(response, onProgress);
        }
        catch (error) {
            clearTimeout(timeoutId);
            if (error instanceof Error && error.name === 'AbortError') {
                throw new ApiError_1.ApiError('Request timeout', 408);
            }
            throw error;
        }
    }
    async uploadToBlob(pathname, content, contentType) {
        const clientToken = await this.getUploadToken(pathname);
        return this.uploadWithClientToken(clientToken, pathname, content, contentType);
    }
    async getUploadToken(pathname) {
        var _a;
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);
        try {
            const response = await fetch(ProApiClient.uploadTokenUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.config.apiToken}`
                },
                body: JSON.stringify({ pathname }),
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            const responseText = await response.text();
            let data;
            try {
                data = JSON.parse(responseText);
            }
            catch (_b) {
                throw new ApiError_1.ApiError(responseText || 'Failed to get upload token', response.status);
            }
            if (!response.ok) {
                throw new ApiError_1.ApiError((_a = data.error) !== null && _a !== void 0 ? _a : 'Failed to get upload token', response.status);
            }
            if (!data.clientToken) {
                throw new ApiError_1.ApiError('No client token returned', 500);
            }
            return data.clientToken;
        }
        catch (error) {
            clearTimeout(timeoutId);
            if (error instanceof ApiError_1.ApiError) {
                throw error;
            }
            if (error instanceof Error && error.name === 'AbortError') {
                throw new ApiError_1.ApiError('Token request timeout', 408);
            }
            throw error;
        }
    }
    async uploadWithClientToken(clientToken, pathname, content, contentType) {
        const blobClient = await Promise.resolve().then(() => __importStar(require('@vercel/blob/client')));
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 120000);
        try {
            const blob = await blobClient.put(pathname, content, {
                access: 'public',
                token: clientToken,
                contentType
            });
            clearTimeout(timeoutId);
            return blob.url;
        }
        catch (error) {
            clearTimeout(timeoutId);
            if (error instanceof ApiError_1.ApiError) {
                throw error;
            }
            if (error instanceof Error && error.name === 'AbortError') {
                throw new ApiError_1.ApiError('Upload timeout', 408);
            }
            if (error instanceof Error) {
                throw new ApiError_1.ApiError(`Upload failed: ${error.message}`, 500);
            }
            throw error;
        }
    }
    async handleStreamingResponse(response, onProgress) {
        var _a;
        const text = await response.text();
        const lines = text.trim().split('\n');
        const messages = [];
        for (const line of lines) {
            if (!line.trim()) {
                continue;
            }
            try {
                const message = JSON.parse(line);
                messages.push(message);
                if (message.type === 'progress' && message.message && onProgress) {
                    onProgress(message.message);
                }
            }
            catch (_b) {
            }
        }
        const errorMessage = messages.find((message) => message.type === 'error');
        if (errorMessage) {
            throw new ApiError_1.ApiError((_a = errorMessage.message) !== null && _a !== void 0 ? _a : 'Unknown API error', response.status);
        }
        const result = this.reassembleChunkedResponse(messages);
        if (!result.code) {
            throw new ApiError_1.ApiError('No result received from API', 500);
        }
        return new ProApiObfuscationResult_1.ProApiObfuscationResult(result.code, result.sourceMap || '');
    }
    reassembleChunkedResponse(messages) {
        var _a, _b, _c;
        const codeChunks = [];
        const sourceMapChunks = [];
        let result = { code: '', sourceMap: '' };
        for (const message of messages) {
            switch (message.type) {
                case 'chunk':
                    if (message.field === 'code' && message.data !== undefined && message.index !== undefined) {
                        codeChunks[message.index] = message.data;
                    }
                    else if (message.field === 'sourceMap' &&
                        message.data !== undefined &&
                        message.index !== undefined) {
                        sourceMapChunks[message.index] = message.data;
                    }
                    break;
                case 'chunk_end':
                    result.code = codeChunks.join('');
                    result.sourceMap = (_a = (sourceMapChunks.join('') || message.sourceMap)) !== null && _a !== void 0 ? _a : '';
                    break;
                case 'result':
                    result = {
                        code: (_b = message.code) !== null && _b !== void 0 ? _b : '',
                        sourceMap: (_c = message.sourceMap) !== null && _c !== void 0 ? _c : ''
                    };
                    break;
            }
        }
        return result;
    }
}
exports.ProApiClient = ProApiClient;
ProApiClient.apiHost = process.env.OBFUSCATOR_API_HOST || 'https://obfuscator.io';
ProApiClient.apiUrl = `${ProApiClient.apiHost}/api/v1/obfuscate`;
ProApiClient.uploadTokenUrl = `${ProApiClient.apiHost}/api/v1/upload/token`;
ProApiClient.defaultTimeout = 300000;
ProApiClient.blobUploadThreshold = 4400000;
ProApiClient.followUpBodyHeadroom = 512;
